import { render, staticRenderFns } from "./ApmsRegThinningBagging.vue?vue&type=template&id=f64af486&scoped=true&"
import script from "./ApmsRegThinningBagging.vue?vue&type=script&lang=js&"
export * from "./ApmsRegThinningBagging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64af486",
  null
  
)

export default component.exports